export const getHeaderClasses = () => {
  return 'px-4 py-2 w-full flex flex-col gap-2 bg-white border-b border-Other/Outlinedborder-stroke';
};
